import Message from './Message';

const List = ({messages, className}) => (
    messages.length > 0 && (
        <ul className={className}>
            {messages.map((message, index) => (
                <Message
                    {...message}
                    key={index}
                />
            ))}
        </ul>
    )
);

export default List;
